<template>
  <div id="app">
    <!--<div id="app" v-loading.fullscreen="loading">-->
    <div v-if="!loading">
      <div v-if="user">
        <main-nav :email="user.email"></main-nav>
        <div>
          <router-view id="main"></router-view>
        </div>
      </div>
      <div v-else>
        <sign-in :onClick="signIn"></sign-in>
      </div>
    </div>
  </div>
</template>

<script>
import { auth, launchSignIn } from './api.js'
import SignIn from './components/SignIn'
import MainNav from './components/MainNav'

export default {
  name: 'app',
  components: { SignIn, MainNav },
  data() {
    return {
      user: null,
      loading: true,
      activeIndex: null
    }
  },
  methods: {
    signIn() {
      this.loading = true
      launchSignIn()
    },
    menuSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    signOut() {
      auth.signOut()
    }
  },
  created() {
    // Show a loading indicator until we figure out of the user is logged in our not
    auth.onAuthStateChanged(user => {
      this.user = user
      this.loading = false
    })
  }
}
</script>

<style lang="stylus">
body
  margin 0px
  background-color rgb(240, 244, 247)

#app
  font-family "Helvetica Neue", Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
  margin 0px

h1
  font-size: 18px
  font-weight: normal
  line-height: 27px

#main
  margin: 20px

.el-card__header
  padding: 18px 20px
  border-bottom: 1px solid #e0e6ed
  box-sizing: border-box

.el-table th
.el-table__header-wrapper thead div
  background-color #e4e7ea
</style>



// WEBPACK FOOTER //
// App.vue?b3f2d632